/**
 *  EndScene
 *
 *  Created by Legman on 24/02/2017.
 *
 */

import Common           from "./Common";
import ScanlinesFilter  from "./ScanlinesFilter";

/**
 * @class
 */
export default class EndScene extends p3.Scene {
    /**
     * @param {!number} [score]
     * @constructor
     */
    constructor(score) {
        super();

        /**
         * @member {number}
         * @private
         */
        this._score = score || 0;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._tvs = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._flint = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._steve = null;

        /**
         * @member {PIXI.extras.BitmapText | PIXI.Text}
         * @private
         */
        this._gameLabel = null;

        /**
         * @member {PIXI.extras.BitmapText | PIXI.Text}
         * @private
         */
        this._overLabel = null;

        /**
         * @member {PIXI.extras.BitmapText | PIXI.Text}
         * @private
         */
        this._scoreLabel = null;

        /**
         * @member {PIXI.extras.BitmapText | PIXI.Text}
         * @private
         */
        this._scoreValueLabel = null;

        /**
         * @member {PIXI.extras.BitmapText | PIXI.Text}
         * @private
         */
        this._bestLabel = null;

        /**
         * @member {PIXI.extras.BitmapText | PIXI.Text}
         * @private
         */
        this._bestValueLabel = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._replayButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._nextButton = null;

        /**
         * @member {PIXI.particles.Emitter}
         * @private
         */
        this._emitter = null;
    }

    init() {
        super.init();

        const assets = Common.assets;

        const bg = new PIXI.Sprite(assets.getTexture("bg_end"));
        this.addChild(bg);

        const holder = new PIXI.Container();
        this.addChild(holder);

        const config = assets.getJSON("end_game_confetti");
        this._emitter = new PIXI.particles.Emitter(holder, [
            assets.getTexture("particle_end_001"),
            assets.getTexture("particle_end_002"),
            assets.getTexture("particle_end_003"),
            assets.getTexture("particle_end_004"),
            assets.getTexture("particle_end_005"),
            assets.getTexture("particle_end_006"),
            assets.getTexture("particle_end_007"),
            assets.getTexture("particle_end_008"),
            assets.getTexture("particle_end_009"),
            assets.getTexture("particle_end_010"),
            assets.getTexture("particle_end_011"),
            assets.getTexture("particle_end_012")
        ], config);
        this._emitter.emit = true;
        let i = Math.floor(Math.random() * 1000);
        while (-- i > 0) {
            this._emitter.update(deltaTime);
        }

        this._tvs = new PIXI.Sprite(assets.getTexture("end_mg"));
        this._tvs.x = p3.View.width * 0.5;
        this._tvs.y = Common.STAGE_HEIGHT * 0.5 - 44;
        this._tvs.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._tvs);

        this._tvs.screens = new PIXI.Sprite(assets.getTexture("end_mg_screens"));
        this._tvs.screens.anchor = new PIXI.Point(0.5, 0.5);
        this._tvs.addChild(this._tvs.screens);

        const filter = new ScanlinesFilter(this._tvs.screens);
        this._tvs.screens.filters = [filter];

        if (webfont) {
            this._gameLabel = new PIXI.Text(translate("results_game_monitor"), {fontSize: "50px", fontFamily: "Arial", fill: 0xBF13A1, align: "center"});
            this._gameLabel.x = -150;
            this._gameLabel.y = -170;
            this._gameLabel.pivot.x = this._gameLabel.width * 0.5;
            this._tvs.screens.addChild(this._gameLabel);
        } else {
            this._gameLabel = new PIXI.extras.BitmapText(translate("results_game_monitor"), {font: "50px Cloudy Bold", align: "center"});
            this._gameLabel.x = -150;
            this._gameLabel.y = -170;
            this._gameLabel.pivot.x = this._gameLabel.textWidth * 0.5;
            this._gameLabel.tint = 0xBF13A1;
            this._tvs.screens.addChild(this._gameLabel);
        }

        if (webfont) {
            this._overLabel = new PIXI.Text(translate("results_over_monitor"), {fontSize: "50px", fontFamily: "Arial", fill: 0xEF041F, align: "center"});
            this._overLabel.x = 22;
            this._overLabel.y = -200;
            this._overLabel.pivot.x = this._overLabel.width * 0.5;
            this._tvs.screens.addChild(this._overLabel);
        } else {
            this._overLabel = new PIXI.extras.BitmapText(translate("results_over_monitor"), {font: "50px Cloudy Bold", align: "center"});
            this._overLabel.x = 22;
            this._overLabel.y = -200;
            this._overLabel.pivot.x = this._overLabel.textWidth * 0.5;
            this._overLabel.tint = 0xEF041F;
            this._tvs.screens.addChild(this._overLabel);
        }

        if (webfont) {
            this._scoreLabel = new PIXI.Text(translate("results_score_monitor"), {fontSize: "50px", fontFamily: "Arial", fill: 0xFFFFFF, align: "center"});
            this._scoreLabel.x = -180;
            this._scoreLabel.y = 20;
            this._scoreLabel.pivot.x = this._scoreLabel.width * 0.5;
            this._tvs.screens.addChild(this._scoreLabel);
        } else {
            this._scoreLabel = new PIXI.extras.BitmapText(translate("results_score_monitor"), {font: "50px Cloudy Bold", align: "center"});
            this._scoreLabel.x = -180;
            this._scoreLabel.y = 20;
            this._scoreLabel.pivot.x = this._scoreLabel.textWidth * 0.5;
            this._tvs.screens.addChild(this._scoreLabel);
        }

        if (webfont) {
            this._scoreValueLabel = new PIXI.Text(this._score.toString(), {fontSize: "60px", fontFamily: "Arial", fill: 0xFFFFFF, align: "center"});
            this._scoreValueLabel.x = -180;
            this._scoreValueLabel.y = 84;
            this._scoreValueLabel.pivot.x = this._scoreValueLabel.width * 0.5;
            this._tvs.screens.addChild(this._scoreValueLabel);
        } else {
            this._scoreValueLabel = new PIXI.extras.BitmapText(this._score.toString(), {font: "60px Cloudy 8bit2", align: "center"});
            this._scoreValueLabel.x = -180;
            this._scoreValueLabel.y = 84;
            this._scoreValueLabel.pivot.x = this._scoreValueLabel.textWidth * 0.5;
            this._tvs.screens.addChild(this._scoreValueLabel);
        }

        if (webfont) {
            this._bestLabel = new PIXI.Text(translate("results_best_monitor"), {fontSize: "50px", fontFamily: "Arial", fill: 0xFFFFFF, align: "center"});
            this._bestLabel.x = 124;
            this._bestLabel.y = 20 + 80;
            this._bestLabel.pivot.x = this._bestLabel.width * 0.5;
            this._tvs.screens.addChild(this._bestLabel);
        } else {
            this._bestLabel = new PIXI.extras.BitmapText(translate("results_best_monitor"), {font: "50px Cloudy Bold", align: "center"});
            this._bestLabel.x = 124;
            this._bestLabel.y = 20 + 80;
            this._bestLabel.pivot.x = this._bestLabel.textWidth * 0.5;
            this._tvs.screens.addChild(this._bestLabel);
        }

        if (webfont) {
            this._bestValueLabel = new PIXI.Text(Common.getHighscore().toString(), {fontSize: "60px", fontFamily: "Arial", fill: 0xFFFFFF, align: "center"});
            this._bestValueLabel.x = 124;
            this._bestValueLabel.y = 84 + 80;
            this._bestValueLabel.pivot.x = this._bestValueLabel.width * 0.5;
            this._tvs.screens.addChild(this._bestValueLabel);
        } else {
            this._bestValueLabel = new PIXI.extras.BitmapText(Common.getHighscore().toString(), {font: "60px Cloudy 8bit2", align: "center"});
            this._bestValueLabel.x = 124;
            this._bestValueLabel.y = 84 + 80;
            this._bestValueLabel.pivot.x = this._bestValueLabel.textWidth * 0.5;
            this._tvs.screens.addChild(this._bestValueLabel);
        }

        this._steve = new PIXI.Sprite(assets.getTexture("end_char_monkey"));
        this._steve.x = p3.View.width * 0.5 + 184;
        this._steve.y = Common.STAGE_HEIGHT * 0.5 - 340;
        this._steve.anchor = new PIXI.Point(0.5, 0.5);
        this._steve.visible = false;
        this.addChild(this._steve);

        this._flint = new PIXI.Sprite(assets.getTexture("end_char_flint"));
        this._flint.x = p3.View.width * 0.5 + 250;
        this._flint.y = Common.STAGE_HEIGHT * 0.5 - 20;
        this._flint.anchor = new PIXI.Point(0.5, 0.5);
        this._flint.visible = false;
        this.addChild(this._flint);

        const top = new PIXI.Sprite(assets.getTexture("end_gradient_top"));
        top.width = p3.View.width;
        this.addChild(top);

        let states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_small_off");
        states.icon = assets.getTexture("icon_replay_off");

        this._replayButton = new p3.Button(states);
        this._replayButton.visible = false;
        this._replayButton.overSoundName = "sfx_btn_press_00";
        this._replayButton.clickSoundName = "sfx_btn_home_00";
        this._replayButton.signals.click.add(this.onReplayButtonClick, this);
        this.addChild(this._replayButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_small_off");
        states.icon = assets.getTexture("icon_home_off");

        this._homeButton = new p3.Button(states);
        this._homeButton.visible = false;
        this._homeButton.overSoundName = "sfx_btn_press_00";
        this._homeButton.clickSoundName = "sfx_btn_home_00";
        this._homeButton.signals.click.add(this.onNextButtonClick, this);
        this.addChild(this._homeButton);

        delay(function() {
            Common.audio.playSound(["sfx_results_reveal_01", "sfx_results_reveal_02", "sfx_results_reveal_03",
                "sfx_results_reveal_04", "sfx_results_reveal_05"]);
        }, 0.4, this);
    }

    destroy() {
        super.destroy();
    }

    appear() {
        super.appear();
    }

    animateIn() {
        // next button
        this._homeButton.scale = new PIXI.Point();
        TweenMax.to(this._homeButton.scale, 0.34, {
            delay: 0.1,
            x: 1.0,
            y: 1.0,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._homeButton.visible = true;
            },
            onStartScope: this
        });

        // replay button
        this._replayButton.scale = new PIXI.Point();
        TweenMax.to(this._replayButton.scale, 0.34, {
            delay: 0.1 + 0.06,
            x: 1.0,
            y: 1.0,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._replayButton.visible = true;
            },
            onStartScope: this
        });

        // flint
        let to = this._flint.x;
        this._flint.x += 200;
        TweenMax.to(this._flint, 0.4, {
            x: to,
            ease: Back.easeOut,
            easeParams: [1],
            onStart: function() {
                this._flint.visible = true;
            },
            onStartScope: this
        });

        // steve
        to = new PIXI.Point(this._steve.x, this._steve.y);
        this._steve.x += 340;
        TweenMax.to(this._steve, 0.6, {
            delay: 0.24,
            bezier: [{x: to.x + 180, y: to.y - 80}, {x: to.x, y: to.y}],
            ease: Back.easeOut,
            easeParams: [1],
            onStart: function() {
                this._steve.visible = true;
            },
            onStartScope: this
        });
    }

    animateOut() {

    }

    resize() {
        this.y = (p3.View.height - Common.STAGE_HEIGHT) * 0.5;

        this._homeButton.x = 100;
        this._homeButton.y = (Common.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;

        this._replayButton.x = p3.View.width - 100;
        this._replayButton.y = (Common.STAGE_HEIGHT + p3.View.height) * 0.5 - 100;

        this._emitter.updateOwnerPos(0.0, (Common.STAGE_HEIGHT - p3.View.height) * 0.5 - 20);
    }

    update() {
        const filter = this._tvs.screens.filters[0];
        filter.time -= deltaTime * 4;

        this._emitter.update(deltaTime);
    }

    /**
     * @param {p3.Button} button
     */
    onReplayButtonClick(button) {
        this.signals.next.dispatch(this);
    }

    /**
     * @param {p3.Button} button
     */
    onScoresButtonClick(button) {
    }

    /**
     * @param {p3.Button} button
     */
    onNextButtonClick(button) {
        this.signals.home.dispatch(this);
    }
}
